import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import AdminTaskPageLayout from '../../../layout/AdminTaskPageLayout';
import { useSelector } from 'react-redux';
import { selectAdminTask } from '../../../store/adminSlices/rallies';
const EditTaskPage = () => {
    const { id, task: taskId } = useParams();
    const task = useSelector(selectAdminTask);
    return _jsx(AdminTaskPageLayout, { formType: 'edit', rallyId: id, taskId: taskId, taskInfo: task });
};
export default EditTaskPage;
